module.exports = __webpack_public_path__ + "img/newsImg.38f05776.png";